<template>
  <div id="performance-summary">
    <HvacUnitTab />
    <div class="white-bg">
      <SystemDetail />
      <HardwareCheck />
      <FilterList />
      <div class="grid-column even-5 gap-50">
        <ActiveAlerts />
        <TuneupDetail />
      </div>
      <SummaryGraph />
      <CycleTable />
      <PerformanceRating />
      <HvacUnitTab />
      <div class="grid-column uneven gap-50">
        <PlanDetail />
        <ComfortCreditDetail />
      </div>
      <PresenterInfo />
      <PartnerLogo />
    </div>
  </div>
</template>
<script>
import SummaryGraph from "@shared/components/customerDetail/performanceSummary/SummaryGraph.vue";
import HvacUnitTab from "@shared/components/customerDetail/performanceSummary/HvacUnitTab.vue";
import customerDetailMixin from "@shared/mixins/customerDetailMixin";
import HardwareCheck from "@shared/components/customerDetail/performanceSummary/HardwareCheck.vue";
import FilterList from "@shared/components/customerDetail/performanceSummary/FilterList.vue";
import ActiveAlerts from "@shared/components/customerDetail/performanceSummary/ActiveAlerts.vue";
import TuneupDetail from "@shared/components/customerDetail/performanceSummary/TuneupDetail.vue";
import SystemDetail from "@shared/components/customerDetail/performanceSummary/SystemDetail.vue";
import CycleTable from "@shared/components/customerDetail/performanceSummary/CycleTable.vue";
import PerformanceRating from "@shared/components/customerDetail/performanceSummary/PerformanceRating.vue";
import PlanDetail from "@shared/components/customerDetail/performanceSummary/PlanDetail.vue";
import ComfortCreditDetail from "@shared/components/customerDetail/performanceSummary/ComfortCreditDetail.vue";
import PresenterInfo from "@shared/components/customerDetail/performanceSummary/PresenterInfo.vue";
import PartnerLogo from "@shared/components/customerDetail/performanceSummary/PartnerLogo.vue";
import { mapState } from "vuex";
import moment from "moment/moment";

export default {
  name: "Index",
  components: {
    PartnerLogo,
    PresenterInfo,
    ComfortCreditDetail,
    PlanDetail,
    PerformanceRating,
    CycleTable,
    SystemDetail,
    TuneupDetail,
    ActiveAlerts,
    FilterList,
    HardwareCheck,
    HvacUnitTab,
    SummaryGraph,
  },
  mixins: [customerDetailMixin],
  computed: {
    ...mapState({
      summaryGraphDate: (state) => state.customerDetail.summaryGraphDate,
      selectedUnit: (state) => state.customerDetail.selectedUnit,
    }),
  },

  watch: {
    selectedUnit() {
      this.setInitialData(this.selectedUnit);
    },
  },
  mounted() {
    if (this.hvac[0]) {
      this.$store.dispatch("changeCustomerDetailValue", {
        field: "selectedUnit",
        value: this.hvac[0],
      });
    }
  },
  methods: {
    setInitialData(hvac) {
      this.$store.dispatch("changeCustomerDetailValue", {
        field: "selectedUnit",
        value: hvac,
      });
      if (this.customer.id) {
        this.$store.dispatch("getComfortCreditBalance", this.customer.id);
        this.$store.dispatch("getCustomerAlert");
      }
      if (hvac.uid) {
        const UID = hvac.uid;
        this.$store.dispatch("getRecentCycles", UID);
        this.$store.dispatch("getLatestRawPayload", UID);
        this.$store.dispatch("getDailyStats", {
          UID,
          startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
#performance-summary {
  display: grid;
  gap: 2rem;
  .white-bg {
    background-color: $WHITE;
    padding: 12px 36px;
    border-radius: 8px;
    display: grid;
    gap: 2.5rem;
  }
}
</style>
